import {CloudIcon, SandboxIcon, ServerIcon, type Icon} from '@primer/octicons-react'
import {MessageCircleIcon} from '@github-ui/custom-icons/MessageCircleIcon'
import styles from '../../components/AgentTypeTrailingVisual.module.css'

/**
 * Default trailing visual for cloud-based agents.
 */
export function DefaultTrailingVisual() {
  return <SessionTypeTrailingVisual icon={CloudIcon} label="Cloud session" testId="agent-type-trailing-visual-cloud" />
}

export function EnvironmentTrailingVisual() {
  return (
    <SessionTypeTrailingVisual
      icon={ServerIcon}
      label="Environment session"
      testId="agent-type-trailing-visual-environment"
    />
  )
}

export function SandboxTrailingVisual() {
  return (
    <SessionTypeTrailingVisual icon={SandboxIcon} label="Sandbox session" testId="agent-type-trailing-visual-sandbox" />
  )
}

export function ChatTrailingVisual() {
  return (
    <SessionTypeTrailingVisual icon={MessageCircleIcon} label="Chat session" testId="agent-type-trailing-visual-chat" />
  )
}

function SessionTypeTrailingVisual({icon: IconComponent, label, testId}: {icon: Icon; label: string; testId: string}) {
  return (
    <span className={styles.wrapper} role="img" aria-label={label} data-testid={testId}>
      <IconComponent />
    </span>
  )
}
